export enum DocumentTypeEnum {
  CI = 1,
  PASSPORT,
  DNI,
}
